import React, { Component } from 'react';
import Header from './Header';
import AppList from './AppList';
import Footer from './Footer';
import './Home.css';
import AppsData from '../assets/apps.json';

class Home extends Component {
  static defaultProps = {
    mailto: "mailto:hifineapp@gmail.com",
  }

  constructor (props) {
    super(props);
    this.state = {showMenu:false};
    this.domHeader = null;
    this.logoTiny = false;
    this.logoBig = false;
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
    this.domHeader = document.querySelector(".app_header");
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
    this.domHeader = null;
  }

  handleScroll(event) {
    if(!this.domHeader) {
      return;
    }
    let scrollY = 0;
    if(window.scrollY) {
      scrollY = window.scrollY;
    } else {
      scrollY = window.pageYOffset;
    }
    this.domHeader.style.height = 'calc(20vh - ' + scrollY + 'px)';
    //console.log(scrollY);
    if(scrollY > (document.documentElement.clientHeight * 0.4 - 50)) {
      if(!this.logoTiny) {
        this.logoBig = false;
        document.querySelector(".svg_logo").classList.add('svg_logo_hide');
        document.querySelector(".logo_title").classList.add('logo_title_show');
        this.logoTiny = true;
      }
    } else {
      if(!this.logoBig) {
        this.logoTiny = false;
        document.querySelector(".logo_title").classList.remove('logo_title_show');
        document.querySelector(".svg_logo").classList.remove('svg_logo_hide');
        this.logoBig = true;
      }
    }
  }

  menuClick() {
    this.setState({showMenu:!this.state.showMenu});
  }

  appListClick() {
    this.setState({showMenu:false});
  }

  render() {
    return (
        <div>
            <Header mailto={this.props.mailto} apps={AppsData} showMenu={this.state.showMenu} onClick={() => this.menuClick()} />
            <AppList apps={AppsData} onClick={() => this.appListClick()} />
            <Footer mailto={this.props.mailto} />
        </div>
    );
  }
}

export default Home;




/*this.apps = [
      {
        appName: "Sunny Beach Hotel",
        appCat:  "Game",
        appIcon: "https://t5.rbxcdn.com/91a7a90e358cc08e7a3348ecdc618a61",
        appBg:   "https://t3.rbxcdn.com/171727c2a5c882353b952b5b0a8a9110",
        appLinkR: "https://www.roblox.com/games/2802686709/Sunny-Beach-Hotel",
      },
      {
        appName: "The Last of Balls",
        appCat:  "Game",
        appIcon: "https://is3-ssl.mzstatic.com/image/thumb/Purple118/v4/fe/4e/f5/fe4ef534-2733-4f1d-af63-47b22734e957/AppIcon-0-1x_U007emarketing-0-85-220-6.png/460x0w.jpg",
        appBg:   "https://is5-ssl.mzstatic.com/image/thumb/Purple118/v4/71/ef/4e/71ef4e11-fece-4d92-c84a-6d580372ae16/pr_source.png/230x0w.jpg",
        appLinkA:"https://itunes.apple.com/app/the-last-of-balls/id1445013249?ls=1&mt=8",
        appLinkG:"https://play.google.com/store/apps/details?id=com.hifineapp.TheLastOfBalls",
      },
      {
        appName: "Hurricane.io",
        appCat:  "Game",
        appIcon: "https://is1-ssl.mzstatic.com/image/thumb/Purple118/v4/14/d9/fb/14d9fbcd-861f-c70f-30e4-07b96f0f678d/AppIcon-1x_U007emarketing-85-220-5.png/460x0w.jpg",
        appBg:   "https://is2-ssl.mzstatic.com/image/thumb/Purple118/v4/b3/4f/f4/b34ff4ff-2d68-e5f8-f5b9-7cae59174a49/pr_source.png/313x0w.png",
        appLinkA:"https://itunes.apple.com/app/hurricane-io/id1281882048?ls=1&mt=8",
        appLinkG:"https://play.google.com/store/apps/details?id=com.hifineapp.Hurricane",
      },
      {
        appName: "Fidget Spinner Sumo",
        appCat:  "Game",
        appIcon: "https://is5-ssl.mzstatic.com/image/thumb/Purple128/v4/d7/26/21/d72621b8-ec1b-89a5-0ae1-cc96c7b1623f/pr_source.png/460x0w.jpg",
        appBg:   "https://is3-ssl.mzstatic.com/image/thumb/Purple128/v4/a8/00/95/a80095bd-3dd7-cb00-1ca9-81ab13d144f2/pr_source.png/313x0w.jpg",
        appLinkA:"https://itunes.apple.com/app/fidget-spinner-sumo-3d-online-fight/id1261289021?ls=1&mt=8",
        appLinkG:"https://play.google.com/store/apps/details?id=com.hifineapp.SpinnerSumo",
      },
      {
        appName: "Drone Racing",
        appCat:  "Game",
        appIcon: "https://is3-ssl.mzstatic.com/image/thumb/Purple122/v4/75/c7/ba/75c7ba46-4c38-6e0c-a785-ce63608b8dbc/mzl.qgdmfjzq.png/460x0w.jpg",
        appBg:   "https://is2-ssl.mzstatic.com/image/thumb/Purple60/v4/44/af/b2/44afb264-6257-ceac-1444-ca62d10eb526/mzl.zjfwpedr.png/313x0w.png",
        appLinkA:"https://itunes.apple.com/app/drone-racing-quadcopter-fpv/id1132013970?ls=1&mt=8",
        appLinkG:"https://play.google.com/store/apps/details?id=com.hifineapp.DroneRacing",
      },
      {
        appName: "Uthred",
        appCat:  "Game",
        appIcon: "https://is1-ssl.mzstatic.com/image/thumb/Purple118/v4/d9/d0/00/d9d0003d-273b-bea5-a765-835244832f11/AppIcon-1x_U007emarketing-85-220-5.png/460x0w.jpg",
        appBg:   "https://is1-ssl.mzstatic.com/image/thumb/Purple128/v4/a3/b8/2f/a3b82fa4-fb79-18ce-526c-813342c114fa/pr_source.png/230x0w.jpg",
        appLinkA:"https://itunes.apple.com/app/uthred-ball-vs-hole/id1420408297?ls=1&mt=8",
        appLinkG:"https://play.google.com/store/apps/details?id=com.hifineapp.uthred",
      },
      {
        appName: "Drift Bottle",
        appCat:  "Social Networking",
        appIcon: "https://is2-ssl.mzstatic.com/image/thumb/Purple125/v4/72/79/db/7279db00-35a6-1fbe-0d5b-73c28277a0da/AppIcon-1x_U007emarketing-85-220-5.png/460x0w.jpg",
        appBg:   "https://is1-ssl.mzstatic.com/image/thumb/Purple115/v4/37/e7/1a/37e71ad0-f3a8-a02e-b222-64a5ef4c9e54/pr_source.png/230x0w.png",
        appLinkA:"https://itunes.apple.com/app/drift-bottle-message-in-bottle/id1383270245?ls=1&mt=8",
      },
    ];*/